import React from 'react';
import { connect } from 'react-redux';
import Header from '../header/Header';
import GuestHeader from '../header/GuestHeader';
import Footer from '../footer/Footer';
import FooterForSEO from '../footer/FooterForSEO';
import { updateSubHeaderHeight, updateSubHeaderLogoHeight } from '../../../actions/webMetaData';
import { getSeoFooterData } from '../../../utils/plpMetaInfo.js';
import AppContainer from '../../../AppContainer';
import { toggleStoreNav } from '../../../actions/webMetaData';
import ScrollToTop from "react-scroll-to-top";
import { segmentEventPush } from '../../../modules/ga/GTMdatalayer';
import { getPageInfo } from '../../../utils/pageInfo';

class DefaultLayout extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    console.log("777==> component Did mount executing");
    const scrollUpBtn = document.getElementById("scrollToTop");
    if (scrollUpBtn) {
      scrollUpBtn.style.outline = "2px solid blue";
      scrollUpBtn.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          scrollUpBtn.click();
        }
      });
    }
    window.addEventListener('load', () => {
      const srFocus = document.getElementById('sr-init-focus');
      if (srFocus) {
        srFocus.focus({ preventScroll: true });

        const skipLink = document.getElementById('skip-link');
        if (skipLink) {
          skipLink.focus({ preventScroll: true });
        }
      }
    });
  }
  render() {
    const {
      header = true,
      footerSeo = false,
      metaData: { sis = false, primaryHeaderHeight = 100 } = {},
      isFooter = true,
      overrideFooterSeoContent = '',
      hidePromiseIconsRowInFooter = false,
      children = []
    } = this.props;
    let marginTop = primaryHeaderHeight;
    const { category = true } = this.props;

    return (
      <div className="regular-store">
        <AppContainer>
          <div id="sr-init-focus" tabindex="-1" style={{position:'absolute', left:`-9999px`, height:`1px`, width:`1px`, overflow:`hidden`}}></div>
          {children[1]?.props?.match?.path === "/my-account/:page" && (
            <a
              className="skip-link"
              tabIndex={0}
              onClick={() => {
                const page = children[1]?.props?.match?.params?.page;
                const targetElement =  document.querySelector("#right-dev-container-accounts");
                const targetElement1 = document.querySelector(".right-dev-container-accounts");
                if (targetElement) {
                  targetElement.focus();
                  targetElement.tabIndex = "-1";
                }
                if(targetElement1) {
                  targetElement1.focus();
                  targetElement1.tabIndex = "-1";
                }
              }}
            >
              Skip To Content
            </a>
          )}
          {header && <Header category={category} />}
          <div className="content" style={{ marginTop: `${marginTop}px` }} role={children[1]?.props?.match?.path === "/my-account/:page" ? null : "main"} >
            {this.props.children}
          </div>
          {footerSeo && <FooterForSEO />}
          {isFooter && (
            <Footer
    
              overrideFooterSeoContent={overrideFooterSeoContent}
              hidePromiseIconsRowInFooter={hidePromiseIconsRowInFooter}
            />
          )}          
          <ScrollToTop
            id="scrollToTop"
            tabIndex={0}
            role="button"
            ContainerClassName='go-to-top-button'
            style={{height:"45px", width: "45px", bottom: "60px", backgroundColor: "#fff", right: "18px"}}
            ToggledStyle={{right: "18px"}}            
            onClickCapture={
              e =>{
                segmentEventPush({
                  event:'Back To Top Clicked', 
                  screen_name: getPageInfo(window.location.href)
                })
              }
            }
          />
        </AppContainer>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { productsAdditionalInfo = {}, metaData = {} } = state;
  const { metaElementData = [] } = productsAdditionalInfo;
  return {
    metaElementData,
    metaData
  };
};
export default connect(mapStateToProps, null)(DefaultLayout);
